<template>
    <div
        class="divide-y divide-dashed"
        :class="[disabled?'cursor-auto':'cursor-pointer']"
    >
        <div
            class="py-1.5 px-2.5 grid   border-l border-r border-solid min-h-[2.5rem] items-center text-sm"
            :class="[disabled?'bg-gray-100 text-gray-400 cursor-auto grid-cols-8':'bg-green-100 text-gray-700 grid-cols-6']"
        >
            <span class="col-span-4">保單號碼 </span>
            <span class="col-span-2">被保險人</span>
            <span
                v-if="disabled"
                class="col-span-2"
            >備註</span>
        </div>
        <div
            v-for="(policy, i) in data"
            :key="i"
            class="py-1.5 px-2.5 grid "
            :class="[disabled?'text-gray-200 grid-cols-8':' text-gray-900 grid-cols-6']"
        >
            <div class="text-base  col-span-4">
                {{ policy.fullPolicyNo }}
            </div>
            <div class="text-base  col-span-2">
                {{ policy.name }}
            </div>
            <div
                v-if="disabled"
                class="text-sm col-span-2 "
            >
                {{ policy.memo }}
            </div>
        </div>
    </div>
</template>

<script>
import { EUDC } from '@/utils/EUDC';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    setup() {
        EUDC();
    }
};
</script>
